function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from "react";
import { noop } from "lodash";
import PostcodeFinderModal from "./FinderModal";
import AddressAutocomplete, { propTypes } from "./AddressAutocomplete";
const {
  onFindClick,
  ...FindPostcodePropTypes
} = propTypes;

const PostcodeFinderInput = ({
  input,
  meta,
  onFindClick,
  onClear,
  onShow,
  onFind,
  onSelectAddress,
  showFindButton,
  classes,
  ...rest
}) => {
  const [addressLookupVisible, setAddressLookupVisible] = useState(false);
  const onFindBtnClick = React.useCallback(() => {
    setAddressLookupVisible(true);
    onFindClick();
  }, [onFindClick, setAddressLookupVisible]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AddressAutocomplete, _extends({
    input: input,
    meta: meta,
    showFindButton: showFindButton,
    onFindClick: onFindBtnClick,
    classes: classes
  }, rest)), /*#__PURE__*/React.createElement(PostcodeFinderModal, {
    classes: rest.modalClasses,
    isOpen: addressLookupVisible,
    search: rest.search,
    onClear: onClear,
    onShow: onShow,
    onFind: onFind,
    onClose: () => setAddressLookupVisible(false),
    onSelect: address => {
      onSelectAddress(address, {
        input,
        meta
      });
      setAddressLookupVisible(false);
    }
  }));
};

PostcodeFinderInput.defaultProps = {
  onFindClick: noop,
  onFind: noop,
  onClear: noop,
  onSelectAddress: noop,
  onShow: noop,
  showFindButton: true,
  classes: {}
};
PostcodeFinderInput.propTypes = { ...FindPostcodePropTypes
};
export default PostcodeFinderInput;